@if(redirect){

<button
  type="button"
  class="btn"
  [class.fit-content]="widthFitContent"
  routerLink="{{ routePath }}"
>
  <p>
    @if(showIcon){
    <ng-icon [size]="iconSize" name="{{ iconName }}"></ng-icon> &nbsp;}
    {{ buttonText }}
  </p>
</button>
} @else {

<button
  type="button"
  class="btn"
  [class.fit-content]="widthFitContent"
  (click)="emitClick()"
>
  <p>
    @if(showIcon){
    <ng-icon [size]="iconSize" name="{{ iconName }}"></ng-icon> &nbsp;}
    {{ buttonText }}
  </p>
</button>
}
